import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AdviserOptionsScreenComponent } from './adviser-options-screen/adviser-options-screen.component';
import { CoverageScreenComponent } from './coverage-screen/coverage-screen.component';
import { DashboardScreenComponent } from './dashboard-screen/dashboard-screen.component';
import { GenericErrorScreenComponent } from './generic-error-screen/generic-error-screen.component';
import { OAuthCallbackScreenComponent } from './oauth-callback-screen/oauth-callback-screen.component';
import { ReviewCompleteScreenComponent } from './review-complete-screen/review-complete-screen.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    CoverageScreenComponent,
    AdviserOptionsScreenComponent,
    ReviewCompleteScreenComponent,
    OAuthCallbackScreenComponent,
    DashboardScreenComponent,
    GenericErrorScreenComponent,
  ],
})
export class ScreensModule {}
